// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2KRz6","image":"Header_image__qY0-o","name":"Header_name__3MSCI","info":"Header_info__3RZtA","infoRow":"Header_infoRow__2RIcW"};